// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__z7+I3","container":"Modal_container__Ha+Ky","closeButton":"Modal_closeButton__Ya+Ev"};